import { render, staticRenderFns } from "./LogisticsListz.vue?vue&type=template&id=a2a33b74&scoped=true"
import script from "./LogisticsListz.vue?vue&type=script&lang=js"
export * from "./LogisticsListz.vue?vue&type=script&lang=js"
import style0 from "./LogisticsListz.vue?vue&type=style&index=0&id=a2a33b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@7.1.2_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a33b74",
  null
  
)

export default component.exports